export function extractStreamingOutputText(event: Record<string, unknown>): string {
  if (event.type === "response.output_text.delta" && typeof event.delta === "string") {
    return event.delta;
  }

  const part = isRecord(event.part) ? event.part : null;
  if (part) {
    const partText = extractTextFromContentPart(part);
    if (partText) return partText;
  }

  const item = isRecord(event.item) ? event.item : null;
  if (item) {
    const itemText = extractTextFromOutputItem(item);
    if (itemText) return itemText;
  }

  const response = isRecord(event.response) ? event.response : null;
  if (response && Array.isArray(response.output)) {
    return response.output.map(extractTextFromOutputItem).join("");
  }

  return "";
}

// Only surface an upstream-provided reasoning summary. Raw/private reasoning
// content is deliberately not treated as user-visible chat text.
export function extractStreamingReasoningSummaryText(event: Record<string, unknown>): string {
  if (
    (event.type === "response.reasoning_summary_text.delta" || event.type === "response.reasoning_text.delta")
    && typeof event.delta === "string"
  ) {
    return event.delta;
  }
  return "";
}

function extractTextFromOutputItem(item: Record<string, unknown>): string {
  if (item.type !== "message" || !Array.isArray(item.content)) return "";
  return item.content
    .map((contentPart) => isRecord(contentPart) ? extractTextFromContentPart(contentPart) : "")
    .join("");
}

function extractTextFromContentPart(part: Record<string, unknown>): string {
  if (
    (part.type === "output_text" || part.type === "text")
    && typeof part.text === "string"
  ) {
    return part.text;
  }
  return "";
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return Boolean(value && typeof value === "object");
}
